import { render, staticRenderFns } from "./WhatsItMean.vue?vue&type=template&id=5173d155&scoped=true&"
import script from "./WhatsItMean.vue?vue&type=script&lang=js&"
export * from "./WhatsItMean.vue?vue&type=script&lang=js&"
import style0 from "./WhatsItMean.vue?vue&type=style&index=0&id=5173d155&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5173d155",
  null
  
)

export default component.exports